"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateEmail = exports.getSalesLoginData = exports.getLoginData = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _ApplicationContext = require("./ApplicationContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// eslint-disable-next-line import/prefer-default-export
const validateEmail = email => {
  const input = document.createElement('input');
  input.type = 'email';
  input.required = true;
  input.value = email;
  return typeof input.checkValidity === 'function' ? input.checkValidity() : /\S+@\S+\.\S+/.test(email);
};
exports.validateEmail = validateEmail;
const getLoginData = () => _axios.default.request({
  url: `${_ApplicationContext.ApplicationContext.getApiBasePath()}/application/consultant/dcio/site/content/get`,
  method: 'get',
  withCredentials: true
});
exports.getLoginData = getLoginData;
const getSalesLoginData = () => _axios.default.request({
  url: `${_ApplicationContext.ApplicationContext.getApiBasePath()}/application/consultant/dcio/sales/content/get`,
  method: 'get',
  withCredentials: true
});
exports.getSalesLoginData = getSalesLoginData;
//# sourceMappingURL=Utils.js.map